<template>
  <v-app>
    <v-content
      class="fondo-login"
      style="height: 100%; position: absolute; width: 100%; overflow-y: auto"
    >

      <FormLoginDeclaracion v-if="mostrar_totales" v-model="dialogRecover"></FormLoginDeclaracion>
      <FormLogin v-if="!mostrar_totales" v-model="dialogReset"></FormLogin>

    </v-content>
  </v-app>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import FormLoginDeclaracion from "./Components/Login_declaracion.vue";
import FormLogin from "./Components/Login_normal.vue";

export default {
  components: {
    FormLoginDeclaracion,
    FormLogin
  },
  data: function () {
    return {
      rfc: null,
      password: null,
      dialog: true,
      mostrarError: false,
      value: false,
      value_l: String,
      dialogRecover: false,
      dialogReset:false,
      mostrar_totales:false
    };
  },
  watch: {
    rfc(newVal) {
      if (newVal.length > 0) {
        this.rfc = newVal.toUpperCase();
      }
    },
  },
  computed: {},
  async mounted() {
    this.$NProgress.done();
    this.get_data_ajustes();
  },
  methods: {

    async get_data_ajustes(){
             try{

                let response = await this.$http.get("get-info-dependencia");

                if(response.data.response){
                    this.mostrar_totales = (response.data.dependencia.mostrar_datos_declaracion == 1) ? true: false;
                }else {
                    this.mostrar_totales = false;
                }

            }catch(error){
                this.mostrar_totales = false;
            }
        },
  },
};
</script>
<style>
.v-responsive__sizer {
  padding-bottom: 80.063% !important;
}
.v-image__image--cover {
  background-size: contain !important;
}
.justify-center {
  justify-content: center;
}

.text-input {
  color: #1ab394;
}

.text-input-error {
  color: red;
}
</style>
